import React from "react";

import { PublicStepConfig, PublicStepTypes } from "onfido-sdk-ui";
import { logger } from "../../lib/utils/logger/logger";
import { IDCheckLoopResponse, VerificationService } from "../../lib/types/types";
import { OnfidoReportNames, VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { getSafe } from "../../lib/utils/objects";

interface IDCheckLoopComponentProps {
  verificationService: VerificationService;
}

const CONTAINER_ID = "onfido";

const IDCheckLoop = ({ verificationService }: IDCheckLoopComponentProps) => {
  const verificationResponse = verificationService.verificationResponse as IDCheckLoopResponse;

  const submitIdCheckLoop = (data: unknown) => {
    logger.info("StepIDCheckLoop submitting ID Check Loop", data);
    verificationService.submitStep(
      VerificationStepsEnum.idCheckLoop,
      verificationService.viewModel,
      verificationService.verificationResponse,
    );
  };

  const initializeOnfido = async () => {
    const onfidoStepConfig: Array<PublicStepTypes | PublicStepConfig> = getSafe(
      () => verificationService.programTheme.config.onfidoReportNames,
      [OnfidoReportNames.DOCUMENT, OnfidoReportNames.FACIAL_SIMILARITY_MOTION],
    ).map((reportName) => {
      if (reportName === OnfidoReportNames.FACIAL_SIMILARITY_MOTION) {
        return { type: "face", options: { requestedVariant: "motion" } };
      }
      return reportName as PublicStepTypes;
    });

    // Onfido needs to be loaded asynchronously to avoid test failures
    import("onfido-sdk-ui").then((Onfido) => {
      Onfido.init({
        containerId: CONTAINER_ID,
        token: verificationResponse.sdkToken,
        onComplete: (data) => {
          submitIdCheckLoop(data);
        },
        steps: [...onfidoStepConfig, "complete"],
      });
    });
  };

  React.useEffect(() => {
    initializeOnfido();
  }, []);

  return <div id={CONTAINER_ID} />;
};

export const IDCheckLoopComponent = IDCheckLoop;
